module.exports = __webpack_public_path__ + "img/18.bffede6d.png";